module.exports = __webpack_public_path__ + "img/control_car.8a8bb432.png";